// extracted by mini-css-extract-plugin
var _1 = "KQ_yV";
var _2 = "jrNKL";
var _3 = "TCFF1";
var _4 = "GzIlL";
export { _1 as "base", _2 as "expand", _3 as "isPopup", _4 as "separator" }
